import { ModalSystemLog } from './ModalSystemLog';
export default ModalSystemLog;